import React from 'react';

export default function StatCard({
  title,
  value,
  subValue,
  subValueType = 'neutral', // 'success' | 'warning' | 'danger' | 'neutral'
  icon: Icon,
  accent = 'green', // 'blue' | 'amber' | 'purple' | 'green'
}) {
  const badgeClass = {
    success: 'badge-green',
    warning: 'badge-amber',
    danger: 'badge-red',
    neutral: 'badge-gray',
  }[subValueType] || 'badge-gray';

  const iconClass = {
    blue: 'stat-icon-blue',
    amber: 'stat-icon-amber',
    purple: 'stat-icon-purple',
    green: 'stat-icon-green',
  }[accent] || 'stat-icon-green';

  return (
    <div className="card stat-card">
      <div>
        <p className="stat-card-title">{title}</p>
        <h3 className="stat-card-value">{value ?? 0}</h3>
        {subValue && (
          <div className="stat-card-footer">
            <span className={`badge ${badgeClass}`}>{subValue}</span>
          </div>
        )}
      </div>
      {Icon && (
        <div className={`stat-card-icon ${iconClass}`}>
          <Icon size={22} />
        </div>
      )}
    </div>
  );
}
